import { useMutation } from '@tanstack/react-query';

import { uploadApprovalDocumentApi } from '../api';

export default function useUploadApprovalDocumentMutation(options?: any) {
  return useMutation(uploadApprovalDocumentApi, options);
}
